import { createRouter, createWebHistory } from "vue-router";
import UserList from "../views/users/List";
import UserEdit from "../views/users/Edit";
import UserCreate from "../views/users/Create";

import DataList from "../views/datas/List";
import DataEdit from "../views/datas/Edit";
import DataCreate from "../views/datas/Create";

import ValueList from "../views/values/List";
import ValueEdit from "../views/values/Edit";
import ValueCreate from "../views/values/Create";

import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";

import ImportData from "../views/import/Data";
import ImportValue from "../views/import/Value";

import multiGuard from "vue-router-multiguard";
import { isAuthenticated } from "../middleware/isAuthenticated";
import { tokenValidated } from "../middleware/tokenValidated";
import { redirectAuthenticated } from "../middleware/redirectAuthenticated";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/import/data",
    name: "ImportData",
    component: ImportData,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/import/value",
    name: "ImportValue",
    component: ImportValue,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/users",
    name: "UserList",
    component: UserList,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/user/:id",
    name: "UserEdit",
    component: UserEdit,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/user/create",
    name: "UserCreate",
    component: UserCreate,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/user/current",
    name: "CurrentUser",
    component: UserCreate,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/datas",
    name: "DataList",
    component: DataList,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/values",
    name: "ValueList",
    component: ValueList,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/data/:id",
    name: "DataEdit",
    component: DataEdit,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/data/create",
    name: "DataCreate",
    component: DataCreate,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/value/:id",
    name: "ValueEdit",
    component: ValueEdit,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/value/create",
    name: "ValueCreate",
    component: ValueCreate,
    beforeEnter: multiGuard([isAuthenticated, tokenValidated]),
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    beforeEnter: multiGuard([redirectAuthenticated]),
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
